export const Arr_AllergiesDietaryInfo = [
  //-------------------------------------------------------------------------
  //Allergy
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have any food allergies",
    name: "allergy_diet_food_allergy",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        For each allergy, we require detailed information to ensure that we can
        facilitate appropriate care for the student should they encounter an
        allergen.
        <br></br>
        <br></br>
        <h3>
          We are unable to accommodate students with airborne food allergies due
          to the high risk of allergen interaction. If your student has an
          airborne allergy, you{" "}
          <i>
            <u>must</u>
          </i>{" "}
          contact info@investin.org to discuss this.
        </h3>
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what it is?",
    name: "allergy_diet_food_allergy_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "allergy_diet_food_allergy_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Confirmation the allergy is not airborne",
    name: "allergy_diet_food_allergy_airborne",
    selectValues: ["The allergy is not airborne"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Triggered by touch",
    name: "allergy_diet_food_allergy_triggered_by_touch",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
    AboveText: (
      <p>
        Can the allergy be triggered when the student touches the allergen (this
        does not include eating/ consuming the allergen)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Triggered by consumption",
    name: "allergy_diet_food_allergy_triggered_by_eating",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
    AboveText: <p>Is the allergy triggered when eaten/ consumed</p>,
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "DateFieldForObjectState",
    label: "Most recent allergic reaction",
    name: "allergy_diet_food_allergy_triggered_last",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
    AboveText: (
      <p>
        Please tell us when the student’s most recent allergic reaction
        occurred. Do not worry if you do not have the exact date, we are more
        interested in the month and year
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "allergy_diet_food_allergy_symptoms ",
    selectValues: [
      {
        name: "allergy_diet_food_allergy_symptoms_Anaphylaxis",
        label:
          "Anaphylaxis – a severe and rapid, potentially life-threatening reaction",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Itchy_throat_mouth",
        label: "Itchy throat/ mouth",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Hives_redness_on_skin",
        label: "Hives or redness on the skin",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Swelling_lips_face_eyes",
        label: "Swelling of the lips, face or eyes",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Coughing_wheezing_breathlessness",
        label: "Coughing, wheezing or breathlessness",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Sneezing_blocked_runny_nose",
        label: "Sneezing or blocked/ runny nose",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_sick_bloated",
        label: "Feeling sick or bloated",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Vomiting",
        label: "Vomiting",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Stomach_cramps_pain",
        label: "Stomach cramps/ pain",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Diarrhoea",
        label: "Diarrhoea",
      },
      {
        name: "allergy_diet_food_allergy_symptoms_Other",
        label: "Other (please specify)",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student consumes something they are allergic to, what are the
        likely symptoms that we should be aware of? Please select all that apply
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the other symptom",
    name: "allergy_diet_food_allergy_symptoms_Other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_symptoms_Other",
  },
  //prescription  Medication
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "allergy_diet_food_allergy_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
    AboveText: (
      <p>
        Does the student have a prescription for life-saving or reactive
        medication if they interact with the allergen?
      </p>
    ),
  },
  //EpiPen
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "allergy_diet_food_allergy_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "allergy_diet_food_allergy_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "allergy_diet_food_allergy_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "allergy_diet_food_allergy_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Prescribed/Other Meds
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "allergy_diet_food_allergy_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication",
    name: "allergy_diet_food_allergy_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: <p>What is the dosage? (e.g. 200mg/ 100mg)</p>,
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "allergy_diet_food_allergy_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        Frequency (e.g. for EpiPens, will one dose be sufficient or will the
        student likely require a second dose, for other allergy medication,
        please tell us if the student will require a second dose)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "allergy_diet_food_allergy_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "allergy_diet_food_allergy_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "allergy_diet_food_allergy_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "allergy_diet_food_allergy_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with any other medicine
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food_allergy_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food_allergy_prescribed_medication_interact_badly",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "allergy_diet_food_allergy_prescribed_medication_interact_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food_allergy_prescribed_medication_interact_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food_allergy_prescribed_medication_interact_storage_requirements",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "allergy_diet_food_allergy_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
        (e.g. please try prescribed antihistamines first, then use the EpiPen if
        this does not alleviate symptoms)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food_allergy_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food_allergy_prescribed_medication_anything_else",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "allergy_diet_food_allergy_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the EpiPen/
        medicine has been administered?)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food_allergy_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_prescribed_medication_aftercare",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "allergy_diet_food_allergy_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food_allergy_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food_allergy_prescribed_medication_storage_requirements",
  },
  //end medication
  //Next OTC
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter antihistamines",
    name: "allergy_diet_food_allergy_prescribed_otc",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_medication",
    AboveText: (
      <p>
        Can the student be given over-the-counter antihistamines if they
        interact with the allergen?
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "allergy_diet_food_allergy_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy?
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food_allergy_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy_anything_else",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have any other food allergies?",
    name: "allergy_diet_food_other_food_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_allergy",
    AboveText: <h3>Does the student have any other food allergies?</h3>,
  },

  //End part 1
  //STart part 2

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what it is?",
    name: "allergy_diet_food2_allergy_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "allergy_diet_food2_allergy_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Confirmation the allergy is not airborne",
    name: "allergy_diet_food2_allergy_airborne",
    selectValues: ["The allergy is not airborne"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Triggered by touch",
    name: "allergy_diet_food2_allergy_triggered_by_touch",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
    AboveText: (
      <p>
        Can the allergy be triggered when the student touches the allergen (this
        does not include eating/ consuming the allergen)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Triggered by consumption",
    name: "allergy_diet_food2_allergy_triggered_by_eating",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
    AboveText: <p>Is the allergy triggered when eaten/ consumed</p>,
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "DateFieldForObjectState",
    label: "Most recent allergic reaction",
    name: "allergy_diet_food2_allergy_triggered_last",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
    AboveText: (
      <p>
        Please tell us when the student’s most recent allergic reaction
        occurred. Do not worry if you do not have the exact date, we are more
        interested in the month and year
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "allergy_diet_food2_allergy_symptoms ",
    selectValues: [
      {
        name: "allergy_diet_food2_allergy_symptoms_Anaphylaxis",
        label:
          "Anaphylaxis – a severe and rapid, potentially life-threatening reaction",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Itchy_throat_mouth",
        label: "Itchy throat/ mouth",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Hives_redness_on_skin",
        label: "Hives or redness on the skin",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Swelling_lips_face_eyes",
        label: "Swelling of the lips, face or eyes",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Coughing_wheezing_breathlessness",
        label: "Coughing, wheezing or breathlessness",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Sneezing_blocked_runny_nose",
        label: "Sneezing or blocked/ runny nose",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_sick_bloated",
        label: "Feeling sick or bloated",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Vomiting",
        label: "Vomiting",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Stomach_cramps_pain",
        label: "Stomach cramps/ pain",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Diarrhoea",
        label: "Diarrhoea",
      },
      {
        name: "allergy_diet_food2_allergy_symptoms_Other",
        label: "Other (please specify)",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student consumes something they are allergic to, what are the
        likely symptoms that we should be aware of? Please select all that apply
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the other symptom",
    name: "allergy_diet_food2_allergy_symptoms_Other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_symptoms_Other",
  },
  //prescription  Medication
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "allergy_diet_food2_allergy_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
    AboveText: (
      <p>
        Does the student have a prescription for life-saving or reactive
        medication if they interact with the allergen?
      </p>
    ),
  },
  //EpiPen
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "allergy_diet_food2_allergy_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "allergy_diet_food2_allergy_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "allergy_diet_food2_allergy_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "allergy_diet_food2_allergy_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Prescribed/Other Meds
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "allergy_diet_food2_allergy_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication",
    name: "allergy_diet_food2_allergy_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "allergy_diet_food2_allergy_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Frequency (e.g. for EpiPens, will one dose be sufficient or will the
        student likely require a second dose, for other allergy medication,
        please tell us if the student will require a second dose)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "allergy_diet_food2_allergy_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "allergy_diet_food2_allergy_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "allergy_diet_food2_allergy_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "allergy_diet_food2_allergy_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with any other medicine
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food2_allergy_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food2_allergy_prescribed_medication_interact_badly",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "allergy_diet_food2_allergy_prescribed_medication_interact_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food2_allergy_prescribed_medication_interact_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food2_allergy_prescribed_medication_interact_storage_requirements",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "allergy_diet_food2_allergy_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
        (e.g. please try prescribed antihistamines first, then use the EpiPen if
        this does not alleviate symptoms)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food2_allergy_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food2_allergy_prescribed_medication_anything_else",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "allergy_diet_food2_allergy_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the EpiPen/
        medicine has been administered?)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food2_allergy_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_prescribed_medication_aftercare",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "allergy_diet_food2_allergy_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food2_allergy_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food2_allergy_prescribed_medication_storage_requirements",
  },
  //end medication
  //Next OTC
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter antihistamines",
    name: "allergy_diet_food2_allergy_prescribed_otc",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_medication",
    AboveText: (
      <p>
        Can the student be given over-the-counter antihistamines if they
        interact with the allergen?
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "allergy_diet_food2_allergy_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy?
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food2_allergy_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_allergy_anything_else",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have any other food allergies?",
    name: "allergy_diet_food2_other_food_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food_other_food_allergies",
    AboveText: <h3>Does the student have any other food allergies?</h3>,
  },

  //End part 2

  //start part 3
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what it is?",
    name: "allergy_diet_food3_allergy_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "allergy_diet_food3_allergy_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Confirmation the allergy is not airborne",
    name: "allergy_diet_food3_allergy_airborne",
    selectValues: ["The allergy is not airborne"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Triggered by touch",
    name: "allergy_diet_food3_allergy_triggered_by_touch",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
    AboveText: (
      <p>
        Can the allergy be triggered when the student touches the allergen (this
        does not include eating/ consuming the allergen)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Triggered by consumption",
    name: "allergy_diet_food3_allergy_triggered_by_eating",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
    AboveText: <p>Is the allergy triggered when eaten/ consumed</p>,
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "DateFieldForObjectState",
    label: "Most recent allergic reaction",
    name: "allergy_diet_food3_allergy_triggered_last",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
    AboveText: (
      <p>
        Please tell us when the student’s most recent allergic reaction
        occurred. Do not worry if you do not have the exact date, we are more
        interested in the month and year
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "allergy_diet_food3_allergy_symptoms ",
    selectValues: [
      {
        name: "allergy_diet_food3_allergy_symptoms_Anaphylaxis",
        label:
          "Anaphylaxis – a severe and rapid, potentially life-threatening reaction",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Itchy_throat_mouth",
        label: "Itchy throat/ mouth",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Hives_redness_on_skin",
        label: "Hives or redness on the skin",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Swelling_lips_face_eyes",
        label: "Swelling of the lips, face or eyes",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Coughing_wheezing_breathlessness",
        label: "Coughing, wheezing or breathlessness",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Sneezing_blocked_runny_nose",
        label: "Sneezing or blocked/ runny nose",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_sick_bloated",
        label: "Feeling sick or bloated",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Vomiting",
        label: "Vomiting",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Stomach_cramps_pain",
        label: "Stomach cramps/ pain",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Diarrhoea",
        label: "Diarrhoea",
      },
      {
        name: "allergy_diet_food3_allergy_symptoms_Other",
        label: "Other (please specify)",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student consumes something they are allergic to, what are the
        likely symptoms that we should be aware of? Please select all that apply
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the other symptom",
    name: "allergy_diet_food3_allergy_symptoms_Other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_symptoms_Other",
  },
  //prescription  Medication
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "allergy_diet_food3_allergy_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
    AboveText: (
      <p>
        Does the student have a prescription for life-saving or reactive
        medication if they interact with the allergen?
      </p>
    ),
  },
  //EpiPen
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "allergy_diet_food3_allergy_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "allergy_diet_food3_allergy_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "allergy_diet_food3_allergy_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "allergy_diet_food3_allergy_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Prescribed/Other Meds
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "allergy_diet_food3_allergy_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication",
    name: "allergy_diet_food3_allergy_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "allergy_diet_food3_allergy_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Frequency (e.g. for EpiPens, will one dose be sufficient or will the
        student likely require a second dose, for other allergy medication,
        please tell us if the student will require a second dose)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "allergy_diet_food3_allergy_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "allergy_diet_food3_allergy_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "allergy_diet_food3_allergy_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "allergy_diet_food3_allergy_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with any other medicine
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food3_allergy_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food3_allergy_prescribed_medication_interact_badly",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "allergy_diet_food3_allergy_prescribed_medication_interact_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food3_allergy_prescribed_medication_interact_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food3_allergy_prescribed_medication_interact_storage_requirements",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "allergy_diet_food3_allergy_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
        (e.g. please try prescribed antihistamines first, then use the EpiPen if
        this does not alleviate symptoms)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food3_allergy_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food3_allergy_prescribed_medication_anything_else",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "allergy_diet_food3_allergy_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the EpiPen/
        medicine has been administered?)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food3_allergy_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_prescribed_medication_aftercare",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "allergy_diet_food3_allergy_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food3_allergy_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "allergy_diet_food3_allergy_prescribed_medication_storage_requirements",
  },
  //end medication
  //Next OTC
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter antihistamines",
    name: "allergy_diet_food3_allergy_prescribed_otc",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_medication",
    AboveText: (
      <p>
        Can the student be given over-the-counter antihistamines if they
        interact with the allergen?
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "allergy_diet_food3_allergy_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food2_other_food_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy?
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_food3_allergy_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_food3_allergy_anything_else",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy?
        <br></br>
        <br></br>
        If you suffer from any additional food related allergies, please let us
        know at info@investin.org
      </p>
    ),
  },

  //end part 3

  //-------------------------------------------------------------------------
  //Diet Allergy

  //Start diet

  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have any dietary needs",
    name: "allergy_diet_does_the_student_have_any_dietary_needs",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: <p>Does the student have any dietary requirements?</p>,
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "allergy_diet_allergies_symptoms ",
    selectValues: [
      {
        name: "allergy_diet_pescatarian",
        label: "Pescatarian",
      },
      {
        name: "allergy_diet_vegan",
        label: "Vegan",
      },
      {
        name: "allergy_diet_vegetarian",
        label: "Vegetarian",
      },
      {
        name: "allergy_diet_halal",
        label: "Halal",
      },
      {
        name: "allergy_diet_kosher",
        label: "Kosher",
      },
      {
        name: "allergy_diet_gluten_free",
        label: "Gluten free",
      },
      {
        name: "allergy_diet_dairy_free",
        label: "Dairy free",
      },
      {
        name: "allergy_diet_egg_free",
        label: "Egg free",
      },
      { name: "allergy_diet_Other", label: "Other (please specify)" },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_does_the_student_have_any_dietary_needs",
    SpecialCondition: "Optional",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the other dietary requirement",
    name: "allergy_diet_Other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_Other",
  },
  //End diet

  //Start food_intolerances
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have any food intolerances",
    name: "allergy_diet_does_the_student_have_any_food_intolerances",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: <p>Does the student have any food intolerance?</p>,
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the food intolerances",
    name: "allergy_diet_food_intolerances_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_does_the_student_have_any_food_intolerances",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the food intolerance",
    name: "allergy_diet_food_intolerances_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_does_the_student_have_any_food_intolerances",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "allergy_diet_food_intolerances ",
    selectValues: [
      {
        name: "allergy_diet_food_intolerances_pain_cramps",
        label: "Pain/ cramps",
      },
      {
        name: "allergy_diet_food_intolerances_nausea_vomiting",
        label: "Nausea/ vomiting",
      },
      {
        name: "allergy_diet_food_intolerances_diarrhoea_upset_stomach",
        label: "Diarrhoea/ upset stomach",
      },
      {
        name: "allergy_diet_food_intolerances_lack_of_appetite",
        label: "Lack of appetite",
      },
      {
        name: "allergy_diet_food_intolerances_feeling_bloated",
        label: "Feeling bloated",
      },
      {
        name: "allergy_diet_food_intolerances_indigestion_heartburn",
        label: "Indigestion/ heartburn",
      },
      {
        name: "allergy_diet_food_intolerances_faigue_brain_fog",
        label: "Fatigue/ brain fog",
      },
      {
        name: "allergy_diet_food_intolerances_Other",
        label: "Other (please specify)",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_does_the_student_have_any_food_intolerances",
    SpecialCondition: "Optional",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the other food intolerances",
    name: "allergy_diet_food_intolerances_Other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "food_intolerances_Other",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student have any prescribed medication that they take related to this food intolerance",
    name: "allergy_diet_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_does_the_student_have_any_food_intolerances",
  },
  // start Food intollerance medication
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "allergy_diet_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication",
    name: "allergy_diet_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency (e.g. two times per day, or only when needed)",
    name: "allergy_diet_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "allergy_diet_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. take with water)",
    name: "allergy_diet_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "allergy_diet_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "allergy_diet_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication_interact_badly",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "allergy_diet_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication_anything_else",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "allergy_diet_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_prescribed_medication_storage_requirements",
  },
  //end medication
  //More not about mediation just the food intolelrance
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter-medicine",
    name: "allergy_diet_prescribed_medication_otc",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_does_the_student_have_any_food_intolerances",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine (such as Buscopan) to alleviate any pain or symptoms above as a
        result
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "allergy_diet_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_does_the_student_have_any_food_intolerances",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        intolerence
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_anything_else",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have any other food allergies?",
    name: "allergy_diet_other_food_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_does_the_student_have_any_food_intolerances",
  },
  //end food_intolerances

  //Start food_intolerances 2
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the food intolerances",
    name: "allergy_diet_2_food_intolerances_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_other_food_allergies",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the food intolerance",
    name: "allergy_diet_2_food_intolerances_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_other_food_allergies",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "allergy_diet_2_food_intolerances ",
    selectValues: [
      {
        name: "allergy_diet_2_food_intolerances_pain_cramps",
        label: "Pain/ cramps",
      },
      {
        name: "allergy_diet_2_food_intolerances_nausea_vomiting",
        label: "Nausea/ vomiting",
      },
      {
        name: "allergy_diet_2_food_intolerances_diarrhoea_upset_stomach",
        label: "Diarrhoea/ upset stomach",
      },
      {
        name: "allergy_diet_2_food_intolerances_lack_of_appetite",
        label: "Lack of appetite",
      },
      {
        name: "allergy_diet_2_food_intolerances_feeling_bloated",
        label: "Feeling bloated",
      },
      {
        name: "allergy_diet_2_food_intolerances_indigestion_heartburn",
        label: "Indigestion/ heartburn",
      },
      {
        name: "allergy_diet_2_food_intolerances_faigue_brain_fog",
        label: "Fatigue/ brain fog",
      },
      {
        name: "allergy_diet_2_food_intolerances_Other",
        label: "Other (please specify)",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_other_food_allergies",
    SpecialCondition: "Optional",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the other food intolerances",
    name: "allergy_diet_2_food_intolerances_Other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "food_intolerances_Other",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student have any prescribed medication that they take related to this food intolerance",
    name: "allergy_diet_2_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_other_food_allergies",
  },
  //Food intollerance medication
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "allergy_diet_2_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication",
    name: "allergy_diet_2_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency (e.g. two times per day, or only when needed)",
    name: "allergy_diet_2_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "allergy_diet_2_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. take with water)",
    name: "allergy_diet_2_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "allergy_diet_2_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "allergy_diet_2_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_2_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication_interact_badly",
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "allergy_diet_2_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_2_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication_anything_else",
  },

  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "allergy_diet_2_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_2_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_prescribed_medication_storage_requirements",
  },

  //end medication
  //More not about mediation just the food intolelrance
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter-medicine",
    name: "allergy_diet_2_prescribed_medication_otc",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_other_food_allergies",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine (such as Buscopan) to alleviate any pain or symptoms above as a
        result
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "allergy_diet_2_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_other_food_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        intolerence
        <br></br>
        If you suffer from any further food intolerances, please email
        info@investin.org to tell us
      </p>
    ),
  },
  {
    Page: "AllergiesDietaryInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "allergy_diet_2_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "allergy_diet_2_anything_else",
  },

  // {
  //   Page: "AllergiesDietaryInfo",
  //   TextField: "SelectFieldForObjectState",
  //   label: "Does the student have any other food allergies?",
  //   name: "allergy_diet_2_other_food_allergies",
  //   selectValues: ["Yes", "No"],
  //   onlyAppearIfValueIs: ["Yes"],
  //   onlyAppearIfValueIsNot: false,
  //   withRegardsTo: "allergy_diet_other_food_allergies",
  // },
  //end food_intolerances 2
];
